import React from 'react';
import { motion } from 'framer-motion';
import './Certifications.css';

const Certifications = () => {
  const certifications = [
    {
      id: 1,
      title: 'AWS Certified Cloud Practitioner',
      issuer: 'Amazon Web Services',
      date: 'November 2025',
      credentialId: '',
      icon: '☁️',
      skills: ['AWS', 'Cloud Computing', 'Cloud Architecture', 'Security'],
      certificateUrl: '/aws_cert.pdf',
    },
    {
      id: 2,
      title: 'AWS Networking',
      issuer: 'KodeKloud',
      date: '2025',
      credentialId: '',
      icon: '🌐',
      skills: ['AWS', 'Networking', 'VPC', 'Cloud Infrastructure'],
      certificateUrl: '/aws_networking.pdf',
    },
    {
      id: 3,
      title: 'AWS EC2',
      issuer: 'KodeKloud',
      date: '2025',
      credentialId: '',
      icon: '🖥️',
      skills: ['AWS', 'EC2', 'Cloud Computing', 'Virtual Machines'],
      certificateUrl: '/aws_ec2.pdf',
    },
    {
      id: 4,
      title: 'AWS S3',
      issuer: 'KodeKloud',
      date: '2025',
      credentialId: '',
      icon: '📦',
      skills: ['AWS', 'S3', 'Object Storage', 'Cloud Storage'],
      certificateUrl: '/aws_s3.pdf',
    },
    {
      id: 5,
      title: 'Kubernetes Foundations',
      issuer: 'KodeKloud',
      date: '2025',
      credentialId: '',
      icon: '⚙️',
      skills: ['Kubernetes', 'Container Orchestration', 'DevOps', 'Cloud Native'],
      certificateUrl: '/kubernetes_foundations.pdf',
    },
    {
      id: 6,
      title: 'Docker Foundations',
      issuer: 'KodeKloud',
      date: '2025',
      credentialId: '',
      icon: '🐳',
      skills: ['Docker', 'Containerization', 'DevOps', 'Microservices'],
      certificateUrl: '/docker_foundations.pdf',
    },
    {
      id: 7,
      title: 'Git Foundations',
      issuer: 'KodeKloud',
      date: '2025',
      credentialId: '',
      icon: '🔀',
      skills: ['Git', 'Version Control', 'GitHub', 'Collaboration'],
      certificateUrl: '/git_foundations.pdf',
    },
    {
      id: 8,
      title: 'DevOps Prerequisite',
      issuer: 'KodeKloud',
      date: '2025',
      credentialId: '',
      icon: '⚙️',
      skills: ['DevOps', 'Linux', 'Networking', 'YAML'],
      certificateUrl: '/devops_prerequisite.pdf',
    },
    {
      id: 9,
      title: 'Linux Level 1',
      issuer: 'KodeKloud',
      date: '2025',
      credentialId: '',
      icon: '🐧',
      skills: ['Linux', 'System Administration', 'Command Line', 'Shell Scripting'],
      certificateUrl: '/linus_level1.pdf',
    },
    {
      id: 10,
      title: 'Git Level 1',
      issuer: 'KodeKloud',
      date: '2025',
      credentialId: '',
      icon: '🔀',
      skills: ['Git', 'Version Control', 'Branching', 'Merging'],
      certificateUrl: '/git_level1.pdf',
    },
    {
      id: 11,
      title: 'Docker Level 1',
      issuer: 'KodeKloud',
      date: '2025',
      credentialId: '',
      icon: '🐳',
      skills: ['Docker', 'Containerization', 'Images', 'Containers'],
      certificateUrl: '/docker_level1.pdf',
    },
  ];

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.15,
      },
    },
  };

  const cardVariants = {
    hidden: { scale: 0.8, opacity: 0 },
    visible: {
      scale: 1,
      opacity: 1,
      transition: { duration: 0.5, ease: 'easeOut' },
    },
  };

  return (
    <div className="certifications">
      <div className="certifications-container">
        <motion.div
          className="certifications-header"
          initial={{ opacity: 0, y: -30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <h1 className="page-title">
            My <span className="gradient-text">Certifications</span>
          </h1>
          <div className="title-underline"></div>
          <div className="certifications-stats">
            <div className="cert-stat">
              <h3>11+</h3>
              <p>Certifications</p>
            </div>
            <div className="cert-stat">
              <h3>Dec 2025</h3>
              <p>Most Recent</p>
            </div>
            <div className="cert-stat">
              <h3>AWS & DevOps</h3>
              <p>Specialization</p>
            </div>
          </div>
          <p className="page-description">
            Professional certifications and achievements demonstrating my commitment to continuous learning
          </p>
        </motion.div>

        <motion.div
          className="certifications-grid"
          variants={containerVariants}
          initial="hidden"
          animate="visible"
        >
          {certifications.map((cert) => (
            <motion.div
              key={cert.id}
              className="cert-card"
              variants={cardVariants}
              whileHover={{ y: -10, scale: 1.03 }}
              transition={{ duration: 0.3 }}
            >
              <div className="cert-icon-wrapper">
                <div className="cert-icon">{cert.icon}</div>
              </div>
              
              <div className="cert-content">
                <h3 className="cert-title">{cert.title}</h3>
                <p className="cert-issuer">{cert.issuer}</p>
                <p className="cert-date">{cert.date}</p>
                
                {cert.credentialId && (
                  <div className="cert-credential">
                    <span className="credential-label">Credential ID:</span>
                    <span className="credential-id">{cert.credentialId}</span>
                  </div>
                )}

                <div className="cert-skills">
                  {cert.skills.map((skill, index) => (
                    <span key={index} className="skill-badge">
                      {skill}
                    </span>
                  ))}
                </div>
              </div>

              <motion.button
                className="verify-btn"
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                onClick={() => cert.certificateUrl ? window.open(cert.certificateUrl, '_blank') : null}
              >
                {cert.certificateUrl ? 'View Certificate' : 'Verify Certificate'}
              </motion.button>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </div>
  );
};

export default Certifications;
